<template>
    <div>
        <template v-if="!wapShow">
            <div>
                <header-hove :tab-index="3"></header-hove>
                <div style="padding: 0 50px;background: #ffffff" class="Dynamics">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="行业资讯" name="1">
                            <div class="box">
                                <div class="li" v-for="item in data2" :key="item.id"  @click="to_detail(item.id)">
                                    <div class="left">
                                        <img v-if="item.listImg" :src="'../../../static/image/information/'+item.listImg">
                                        <img v-else src="@/assets/image/default.png" />
                                    </div>
                                    <div class="right">
                                        <div class="name">{{item.title}}</div>
                                        <div class="subtitle">{{item.subtitle}}</div>
                                        <div class="time">{{item.time}}</div>
                                    </div>    <div style="clear: both"></div>
                                </div>

                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="公司动态" name="2">
                            <div class="box">
                                <div class="li" v-for="item in data1" :key="item.id" @click="to_detail(item.id)">
                                    <div class="left">
                                        <img v-if="item.listImg" :src="'../../../static/image/information/'+item.listImg"/>
                                        <img src="@/assets/image/default.png" v-else  />
                                    </div>
                                    <div class="right">
                                        <div class="name">{{item.title}}</div>
                                        <div class="subtitle">{{item.subtitle}}</div>
                                        <div class="time">{{item.time}}</div>
                                    </div>    <div style="clear: both"></div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <footers></footers>
            </div>
        </template>
        <template v-else>
            <information-wap></information-wap>
        </template>
    </div>
</template>

<script>
    import Footers from "@/components/footer";
    import HeaderHove from "@/components/headerHove";
    import eventBus from "@/assets/js/eventBus";
    import informationWap from "./wap/index"
    export default {
        name: "InformationDynamics",
        components:{HeaderHove, Footers,informationWap},
        data(){
            return{
                activeName:"1",
                data1:[],
                data2:[],
                wapShow:false,
            }
        },
        watch:{
            '$route': function (to, from) {
                if(this.$route.query.type){
                    this.activeName = this.$route.query.type;
                }
            }
        },
        mounted() {
             this.data1 =require('../../assets/JSONData/Information/company.json');
             this.data2 =require('../../assets/JSONData/Information/InformationDynamics.json');
             if (this.$route.query.type) {
                this.activeName =this.$route.query.type;
             }
            if(this.$route.query) this.wapShow = this.$route.query.wapShow;
            eventBus.$on("wapShow",(data)=>{
                this.wapShow= data;
            })
        },
        methods:{
            handleClick(data){
                // console.log(data)
            },
            to_detail(id){
                this.$router.push('/InformationDynamicsDetail?id='+id)
            }
        }
    }
</script>

<style scoped>
    .box .li{
        padding-bottom: 30px;
        border-bottom:1px solid #E6E8EB;
        position: relative;
        cursor: pointer;
        margin-bottom: 20px;
    }
    .box .li .left{
        width: 340px;
        height: 200px;
        border-radius: 10px;
        float: left;
    }
    .box .li .left img{
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }
    .box .li .right {
        text-align: left;
        float: left;
        width: 740px;
        padding-left: 38px;
        box-sizing: border-box;
    }
    .box .li .name {
        font-size: 24px;
        font-family: MicrosoftYaHei;
        color: #363A44;
        line-height: 24px;
    }
    .box .li .subtitle {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #999999;
        line-height: 24px;
        margin-top: 20px;
    }
    .box .li .time {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #363A44;
        position: absolute;
        bottom: 40px;
        left: 380px;
    }
</style>

<style>
    .Dynamics .el-tabs__active-bar{
        background: rgba(0, 103, 172, 1) !important;
    }
    .Dynamics .el-tabs__nav{
        width: 100% !important;
        border-bottom: 1px solid #E6E8EB;
    }
    .Dynamics .el-tabs__header{
        margin: 0 0 30px !important;
    }
    .Dynamics .el-tabs__item{
        width: 50% !important;
        border: 0 !important;
        font-size: 16px !important;
        font-family: MicrosoftYaHei !important;
        color: #0067AC !important;
        background: #ffffff;
        height: 41px !important;
    }
    .Dynamics .el-tabs--border-card{
        border: 0 !important;
        box-shadow: none !important;
    }
    .Dynamics .box{
        min-height: 500px;
    }
    .Dynamics .box .li{

    }
</style>
